export default __webpack_public_path__ + "static/media/report_active.173db9e8.svg";